export default __webpack_public_path__ + "static/media/Magnilda 400.7c271596.ttf";